const Group = <template>
  <a href="{{@ctx.baseuri}}/groups/{{@ctx.group.name}}">{{@ctx.group.name}}</a>
</template>;

export default Group;
